<div
  class="venue-address-display cursor-pointer"
  *ngIf="venueLine || streetLine || cityStateZipCountryLine"
  [class.venue-address-display--with-map]="mapIconConfig?.showMapIcon"
  (click)="allowModalOpening && openLocationModal($event)"
>
  <span
    *ngIf="mapIconConfig?.showMapIcon && mapIconConfig?.showMapIconOnLeft"
    role="button"
    tabindex="0"
    class="venue-address-display__map-icon flex-shrink-0"
    [class.venue-address-display__map-icon--interactive]="canOpenLocationModal"
  >
    <em
      class="icon-liteic_location-copy"
      [style.font-size]="mapIconConfig?.fontSize"
    ></em>
  </span>
  <div class="venue-address-display__lines">
    <div *ngIf="streetLine" class="venue-address-display__line">
      <ng-container *ngIf="venueLine">{{ venueLine }} - </ng-container>
      {{ streetLine }}
    </div>
  
    <div *ngIf="!streetLine && (venueLine || cityStateZipCountryLine)" class="venue-address-display__line">
      <ng-container *ngIf="venueLine">{{ venueLine }}</ng-container>
      <ng-container *ngIf="venueLine && cityStateZipCountryLine"> - </ng-container>
      <ng-container *ngIf="cityStateZipCountryLine">{{ cityStateZipCountryLine }}</ng-container>
    </div>
  </div>
  <span *ngIf="showDirectionIcon" class="venue-address-display__direction-icon">
    <em class="icon-liteTraffic" [style.font-size]="mapIconConfig?.fontSize"></em>
  </span>
  <span
    *ngIf="mapIconConfig?.showMapIcon && !mapIconConfig?.showMapIconOnLeft"
    role="button"
    tabindex="0"
    class="venue-address-display__map-icon flex-shrink-0"
    [class.venue-address-display__map-icon--interactive]="canOpenLocationModal"
  >
    <em
      class="icon-liteic_location-copy"
      [style.font-size]="mapIconConfig?.fontSize"
    ></em>
  </span>
</div>

<app-alert-modal
  #venueLocationModal
  [headerLabel]="headerLabel"
  [confirmBtnLabel]="LABELS.GET_DIRECTIONS"
  (confirmed)="onGetDirections()"
  [modalOptions]="{ class: 'modal-lg' }"
>
  <div class="venue-address-display__modal-content">
    <img
      *ngIf="address.preview_image_url || address?.product_image"
      appDisableRightClick
      appMobileOptimization
      [originalUrl]="address.preview_image_url"
      [src]="address.preview_image_url"
      [width]="100"
      [height]="100"
      [format]="'webp'"
      class="img-fluid"
      alt="Event Preview Image"
      loading="lazy"
      decoding="async"
    />
    <div class="venue-address-display__modal-body">
      <span class="venue-address-display__modal-header">
        {{ modalVenueName || LABELS.MODAL_HEADER_FALLBACK }}
      </span>
      <div
        *ngFor="let line of completeFormattedAddress; let i = index;"
        class="venue-address-display__modal-line"
      >
        {{ line }}
      </div>
      <div class="venue-address-display__modal-time">
        {{ venueTime }}
      </div>
    </div>
  </div>
</app-alert-modal>
